/**
 * Every TanStack Query key the app uses, in one place.
 *
 * Invalidation matches by prefix, so the shapes matter: invalidating
 * `scans(orderId)` refreshes the gallery's and the editor's `scansView`
 * entries for that order too. Add new keys here rather than inline.
 *
 * Ids are typed loosely because route params are `undefined` until a page's
 * guard runs, and those queries are disabled until then anyway.
 */
type Id = string | null | undefined;

export const queryKeys = {
  orders: () => ['orders'] as const,
  /** Prefix for every view of an order's scans. */
  scans: (orderId: Id) => ['scans', orderId] as const,
  /** The gallery's (and the editor's) scans for an order; `preview` is the admin preview. */
  scansView: (orderId: Id, preview: boolean) => ['scans', orderId, preview] as const,
  printPricing: () => ['print-pricing'] as const,
  admin: {
    orders: () => ['admin', 'orders'] as const,
    order: (orderId: Id) => ['admin', 'order', orderId] as const,
    rolls: (orderId: Id) => ['admin', 'rolls', orderId] as const,
    booking: (orderId: Id) => ['admin', 'booking', orderId] as const,
    labQueue: () => ['admin', 'lab-queue'] as const,
    labNumber: (number: Id) => ['admin', 'lab-number', number] as const,
    printOrders: () => ['admin', 'print-orders'] as const,
    filmStocks: () => ['admin', 'film-stocks'] as const,
    download: (orderId: Id, jobId: Id) => ['admin-download', orderId, jobId] as const,
  },
};
